import { set } from "@/utils/vuex";

export default {
  setImpactBusinessList: set("list"),
  setLoading: set("loading"),
  setCurrentProfile: set("currentProfile"),
  setKeywordToBusinessID: set("keywords"),
  setFilteredList: set('filteredList')
};
